import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

import { ApiError, login } from './api'

export default function LoginPage() {
  const queryClient = useQueryClient()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const mutation = useMutation({
    mutationFn: () => login(email, password),
    onSuccess: (profile) => {
      queryClient.setQueryData(['me'], profile)
    },
  })

  const error = mutation.error instanceof ApiError ? mutation.error.message : null

  return (
    <main className="narrow">
      <h1>Вход</h1>
      <p className="subtitle">
        Оргструктура и бизнес-процессы. Аккаунты выдаёт администратор — самостоятельной
        регистрации нет.
      </p>

      <form
        className="card"
        onSubmit={(event) => {
          event.preventDefault()
          mutation.mutate()
        }}
      >
        <label className="field">
          <span>Email</span>
          <input
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        <label className="field">
          <span>Пароль</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>

        {error && <p className="bad form-error">{error}</p>}

        <button type="submit" disabled={mutation.isPending}>
          {mutation.isPending ? 'Проверяем…' : 'Войти'}
        </button>
      </form>
    </main>
  )
}
